<template>
  <div class="hello">
    <div id="container">
      <img :src="require('../assets/main_' + $i18n.locale +'.png')" id="main" @load="loadMain">
      <div class="page page1">
        <img class="move" src="../assets/1.png">
        <img class="begin" :src="require('../assets/begin_' + $i18n.locale + '.png')" @click="changePage('next')">
      </div>
      <div class="page page2">
        <img class="move" src="../assets/2.png">
      </div>
      <div class="page page3">
        <img class="move" src="../assets/3.png">
      </div>
      <div class="page page4">
        <img class="move" src="../assets/4.png">
      </div>
      <div class="page page5">
        <img class="move" src="../assets/5.png">
      </div>
      <div class="page page6">
        <img class="move1" :src="require('../assets/6_' + $i18n.locale + '.png')">
      </div>
      <div class="page page7">
        <img class="move" src="../assets/7.png">
      </div>
      <div class="page page8">
        <img class="move" src="../assets/8.png">
      </div>
      <div class="page page9">
        <img class="move" src="../assets/9.png">
        <div v-if="isTP">
          <img class="end" :src="require('../assets/stop_' + $i18n.locale + '.png')" @click="close">
          <img class="share" :src="require('../assets/share1_' + $i18n.locale + '.png')" @click="share">
          <img class="test test1"
               :src="require('../assets/test_' + $i18n.locale + '.png')"
               @click="toTest"
          >

        </div>
        <div v-else>
          <img class="download" :class="$i18n.locale" :src="require('../assets/download_' + $i18n.locale + '.png')" @click="download">
          <img class="test test2"
               :src="require('../assets/test_' + $i18n.locale + '.png')"
               @click="toTest"
          >
        </div>
      </div>
    </div>
    <div class="switch-container" v-if="page !== 1 && page !== 9">
      <img src="../assets/left.png" @click="changePage('prev')">
      <img src="../assets/right.png" @click="changePage('next')">
    </div>
    <img class="close" src="../assets/close.png" @click="close()">
  </div>
</template>

<script>

let tp = require('tp-js-sdk')
import $ from 'jquery'

export default {
  name: 'HelloWorld',
  data() {
    return {
      page: 1,
    }
  },
  computed: {
    isTP() {
      return navigator.userAgent.indexOf('TokenPocket') > -1
    }
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.loadMain('resizePage')
    })
  },
  methods: {
    close() {
      if (window.history.length > 1) {
        window.history.go(-1)
      } else {
        tp.close()
      }
    },
    share() {
      tp.shareNewsToSNS({
        title: this.$t('shareTitle'),
        desc: this.$t('shareDesc'),
        url: location.href,
        previewImage: 'https://tp-statics.tokenpocket.pro/banner/tokenpocket-202107051811.png'
      })
    },
    download() {
      window.location = 'https://download.tokenpocket.pro/index.html?new#/'
    },
    toTest() {
      window.location = this.$t('testUrl')
    },
    changePage(type) {
      const container = $('#container')
      const body = $('body')
      let marginLeft
      // if(container.is(':animated')) return false
      // const marginLeft = Math.round(parseFloat(container.css('marginLeft')))
      if (type === 'prev') {
        this.page -= 1
        // container.stop().animate({'marginLeft': (-100) * (this.page - 1) + '%'}, 'slow')
      } else if (type === 'next') {
        this.page += 1
        // container.stop().animate({'marginLeft': (-100) * (this.page - 1) + '%'}, 'slow')
      }
      if (this.page >= 2 && this.page <= 8) {
        body.css('backgroundColor', '#16111f')
      } else {
        body.css('backgroundColor', 'black')
      }
      marginLeft = (this.page - 1) * this.width / 9 + (this.width / 9 - this.offsetWidth) / 2
      container.css('marginLeft', -marginLeft + 'px')
      if (type === 'prev' || type === 'next') {
        body.css('opacity', 0.2)
        body.stop().animate({'opacity' : 1}, 1500)
      }
    },
    loadMain(type) {
      const width = $('#main').width()
      const container = $('#container')
      if (document.body.offsetWidth / document.body.offsetHeight > 0.5625) {
        $('body').css('width', document.body.offsetHeight * 0.5625 + 'px')
      }
      const left = (document.body.offsetWidth - width / 9) / 2
      this.width = width
      this.offsetWidth = document.body.offsetWidth
      container.css('width', width / 9 + 'px')
      if (type === 'resizePage') {
        this.changePage()
      } else {
        container.css('marginLeft', left + 'px')
      }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.hello {
  overflow: hidden;
  position: relative;
  background-color: black;

  #container {
    height: 100%;
    position: relative;
    #main {
      height: 100vh;
      display: block;
      margin-left: 0;
    }
    .page {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      overflow: hidden;
      .move {
        position: absolute;
        animation: move 5s infinite;
      }
    }
    .page1 {
      left: 0;
      width: 100%;
      .begin {
        position: absolute;
        height: 7.4%;
        top: 81.3%;
        left: 0;
        right: 0;
        margin: auto;
      }
      .move {
        height: 46%;
        top: 41.5%;
        right: 44%;
      }
    }
    .page2 {
      left: 100%;
      .move {
        height: 50%;
        top: 24%;
        left: 53%;
      }
    }
    .page3 {
      left: 200%;
      .move {
        height: 36%;
        top: 35.5%;
        right: 58%;
      }
    }
    .page4 {
      left: 300%;
      .move {
        height: 14%;
        left: 0;
        right: 0;
        top: 50.5%;
        margin: auto;
      }
    }
    .page5 {
      left: 400%;
      .move {
        height: 39.4%;
        top: 38%;
        right: 36%;
      }
    }
    .page6 {
      left: 500%;
      .move1 {
        height: 31%;
        left: 0;
        right: 0;
        top: 30%;
        margin: auto;
        position: absolute;
        animation: move1 5s infinite;
      }
    }
    .page7 {
      left: 600%;
      .move {
        height: 55%;
        right: -53%;
        top: 30%;
      }
    }
    .page8 {
      left: 700%;
      .move {
        height: 60%;
        top: 45%;
        right: 35%;
      }
    }
    .page9 {
      left: 800%;
      .move {
        height: 54%;
        top: 29.1%;
        right: 25%;
      }
      .end {
        position: absolute;
        height: 7.39%;
        top: 69%;
        left: 0;
        right: 0;
        margin: auto;
      }
      .share {
        position: absolute;
        height: 4%;
        top: 90%;
        left: 0;
        right: 0;
        margin: auto;
      }
      .download {
        position: absolute;
        height: 7.39%;
        top: 72.5%;
        left: 0;
        right: 0;
        margin: auto;

        &.en {
          height: 10%;
          top: 70%;
        }
      }
      .test {
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
      }
      .test1 {
        height: 7.39%;
        top: 78.5%;
      }
      .test2 {
        height: 8%;
        top: 82.5%;
      }
    }
  }

  .switch-container {
    position: absolute;
    top: 88.2%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      height: 5.23vh;
    }
    img:last-child {
      margin-left: 12.7%;
    }
  }
  .close {
    position: absolute;
    height: 3.95%;
    right: 5.33%;
    top: 3.45%;
  }
}
@keyframes move {
  0% {
    margin-top: -3%;
  }
  50% {
    margin-top: 3%;
  }
  100% {
    margin-top: -3%;
  }
}
@keyframes move1 {
  0% {
    margin-top: -1.5%;
  }
  50% {
    margin-top: 1.5%;
  }
  100% {
    margin-top: -1.5%;
  }
}
</style>
